var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { SgdfElement } from '../../internal/sgdf-element.js';
import styles from './sidebar.styles.js';
let SgdfSidebar = class SgdfSidebar extends SgdfElement {
    render() {
        return html `
            <aside class="container">
                <div class="content">
                    <ul class="list">
                        <slot></slot>
                    </ul>
                </div>
            </aside>
        `;
    }
};
SgdfSidebar.styles = styles;
SgdfSidebar = __decorate([
    customElement('sgdf-sidebar')
], SgdfSidebar);
export { SgdfSidebar };
//# sourceMappingURL=sidebar.js.map